import { gql } from "@apollo/client";

export const QUERY_EQUITY_TIMELINE = gql`
  query EquityTimeline {
    response: equityTimeline {
      timeline
    }
  }
`;
